// Системные папки
export const ClusteringSystemArts = {
    // Все папки
    ROOT: 0,
    // Нераспределенные
    UNALLOCATED: -1,
    // Удаленные
    DELETED: -2,
    // Результат кластеризации
    CLUSTER_RESULT: -3
}
